import { Configuration } from "@azure/msal-browser";
import { Environment, DdbEnvironment } from "../shared/types";
import { Snippet, DistributedTracingModes } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { PostHogConfig } from "posthog-js";
import PackageJSON from "../../package.json";

/* application metadata */
export const { name, version } = PackageJSON;

/* environment variables */
export const ENVIRONMENT =
  process.env.ENVIRONMENT !== undefined ? (String(process.env.ENVIRONMENT) as Environment) : Environment.Local;
export const MSAL_CLIENT_ID = process.env.MSAL_CLIENT_ID !== undefined ? String(process.env.MSAL_CLIENT_ID) : "";
export const MSAL_AUTHORITY = process.env.MSAL_AUTHORITY !== undefined ? String(process.env.MSAL_AUTHORITY) : "";
export const POSTHOG_API_KEY = process.env.POSTHOG_API_KEY !== undefined ? String(process.env.POSTHOG_API_KEY) : "";
export const POSTHOG_HOST = process.env.POSTHOG_HOST !== undefined ? String(process.env.POSTHOG_HOST) : "";
export const APPINSIGHTS_CONNECTION_STRING =
  process.env.APPINSIGHTS_CONNECTION_STRING !== undefined ? String(process.env.APPINSIGHTS_CONNECTION_STRING) : "";

/* ddb environment */
function ddbEnvironment(): DdbEnvironment {
  switch (ENVIRONMENT) {
    default:
      return DdbEnvironment.Develop;
    case Environment.UT:
      return DdbEnvironment.Sandbox;
    case Environment.Production:
      return DdbEnvironment.Production;
  }
}

export const DDB_ENVIRONMENT: DdbEnvironment = ddbEnvironment();

/* application insights configuration */
export const REACT_PLUGIN = new ReactPlugin();
export const APPLICATION_INSIGHTS_CONFIG: Snippet["config"] = {
  connectionString: APPINSIGHTS_CONNECTION_STRING,
  enableDebug: ENVIRONMENT === Environment.Local || ENVIRONMENT === Environment.Development,
  distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
  enableCorsCorrelation: true,
  enableAjaxPerfTracking: true,
  enableRequestHeaderTracking: true,
  enableResponseHeaderTracking: true,
  autoTrackPageVisitTime: true,
  enableAutoRouteTracking: true,
  extensions: [REACT_PLUGIN],
  extensionConfig: { [REACT_PLUGIN.identifier]: { enableAutoRouteTracking: true } },
};

/* posthog configuration */
export const POSTHOG_CONFIG: Partial<PostHogConfig> = { api_host: POSTHOG_HOST };

/* msal configuration */
export const MSAL_CONFIG: Configuration = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: MSAL_AUTHORITY,
    redirectUri: "/",
  },
  telemetry: {
    application: {
      appName: name,
      appVersion: version,
    },
  },
};
